import { College } from "src/games/UniversityGame/objects/College";

export class Student {
    public complete: boolean;
    public greeting: string;
    public object: Phaser.Physics.Arcade.Sprite;
    public frame: string;
    public college: College;
    public goodbye: string;
    public icon: Phaser.GameObjects.Image;

    constructor(greeting: string, goodbye: string, frame: string, college: College) {
        this.complete = false;
        this.object = null;
        this.greeting = greeting;
        this.goodbye = goodbye;
        this.frame = frame;
        this.college = college;
    }

    public static STUDENTS: Student[] = [
        new Student("University.Phaser.NPCs.businessStudent.greeting", "University.Phaser.NPCs.businessStudent.goodbye", 'sleb-2', new College("business", "University.Phaser.Colleges.business")),
        new Student("University.Phaser.NPCs.engineeringStudent.greeting", "University.Phaser.NPCs.engineeringStudent.goodbye", "sleb-1", new College("engineering", "University.Phaser.Colleges.engineering")),
        new Student("University.Phaser.NPCs.artsStudent.greeting", "University.Phaser.NPCs.artsStudent.goodbye", 'squeelo-1', new College("arts", "University.Phaser.Colleges.arts")),
        new Student("University.Phaser.NPCs.medicalStudent.greeting", "University.Phaser.NPCs.medicalStudent.goodbye", 'snib-1', new College("medical", "University.Phaser.Colleges.medical")),
    ];

}



// WEBPACK FOOTER //
// ./src/games/UniversityGame/objects/Student.ts